import { sidebarIcons } from 'src/layouts/SidebarV2/icons';
import { NavItem } from 'src/layouts/SidebarV2/primitives';
import type { NavItemModel } from 'src/layouts/SidebarV2/types';

export interface AdminConsoleNavProps {
  items: NavItemModel[];
  collapsed?: boolean;
  onExpand?: () => void;
}

const AdminConsoleNav = ({
  items,
  collapsed = false,
  onExpand
}: AdminConsoleNavProps) => {
  return (
    <nav
      className={
        collapsed
          ? 'tw:flex tw:flex-col tw:items-center tw:gap-3xs tw:w-full'
          : 'tw:flex tw:flex-col tw:gap-3xs tw:w-full'
      }
    >
      {collapsed && onExpand ? (
        <NavItem
          name="Expand"
          icon={sidebarIcons.layoutLeft}
          onClick={onExpand}
          collapsed
        />
      ) : null}

      {items.map((item) => (
        <NavItem
          key={item.id}
          name={item.name}
          icon={item.icon}
          to={item.to}
          onClick={item.onClick}
          selected={item.active}
          collapsed={collapsed}
        />
      ))}
    </nav>
  );
};

export { AdminConsoleNav };
